import { ModelText } from '@cadstrom/cadstrom-shared';
import { useMemo } from 'react';

import { useCoreModelContext } from '#components/cad-renderer/context/core-model-context.js';

/**
 * Returns the display conventions supported by the current project's CAD provenance.
 *
 * @returns The project-tool dialect followed by Cadstrom conventions, or Cadstrom only without model context.
 */
export function useModelTextDialects(): ModelText.TextDialect[] {
	const coreModelContext = useCoreModelContext(false);
	return useMemo(
		() =>
			coreModelContext ?
				[ModelText.getTextDialectForCadTool(coreModelContext.coreModel.type), ModelText.TextDialect.Cadstrom]
			:	[ModelText.TextDialect.Cadstrom],
		[coreModelContext?.coreModel.type],
	);
}
